
import agreedToCompleted from "./time-period";
import revTypeByTimePeriod from "./rev-type-by-time-period";

export default [...agreedToCompleted, ...revTypeByTimePeriod];